<template>

  <el-row>
    <el-col :span="24">
      <div class="grid-content bg-purple-light">
        <div class="search-content" >
          <el-col :span="24" class="toobar">
            <el-input style="width:140px;"  placeholder="门店名称"   v-model="searchdata.dname"> </el-input>
            <el-input style="width:140px;"  placeholder="地址"   v-model="searchdata.address"> </el-input>
            <el-select v-model="searchdata.region" placeholder="区域" clearable style="width:100px;">
              <el-option  v-for="item in regionlist"  :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-select v-model="searchdata.nature" placeholder="性质" clearable style="width:100px;">
              <el-option  v-for="item in naturelist"  :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-select v-model="searchdata.level" placeholder="等级" clearable style="width:100px;">
              <el-option  v-for="item in levellist"  :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-button type="warning" @click="excelPort"  >导出</el-button>
            <DeptEdit ref="DataContactEdit" @bindGrid="bindGrid"></DeptEdit>
          </el-col>
        </div>
        <el-table
          :data="tableData.filter(o=>(!searchdata.dname||o.dname.toLowerCase().includes(searchdata.dname.toLowerCase()))&&
          (!searchdata.address||o.address.toLowerCase().includes(searchdata.address.toLowerCase()))&&
          (!searchdata.region||o.region==searchdata.region)&&
          (!searchdata.nature||o.nature==searchdata.nature)&&
          (!searchdata.level||o.deptlevel==searchdata.level)
          )"
          :height="tableHeight()"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            width="60" fixed
            label="序号" :show-overflow-tooltip="true"
            align="center" >
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="serialnum"-->
            <!--label="编码"-->
            <!--align="left" fixed-->
            <!--header-align="center"-->
            <!--width="60">-->
          <!--</el-table-column>-->
          <el-table-column
            prop="dname"
            label="门店" fixed
            align="left" width="200"  :show-overflow-tooltip="true"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="deptlevel"
            align="center"
            header-align="center"  :show-overflow-tooltip="true"
            label="等级"
            width="50">
          </el-table-column>
          <el-table-column
            prop="nature"
            align="center"
            header-align="center"  :show-overflow-tooltip="true"
            label="性质"
            width="80">
          </el-table-column>
          <el-table-column
            prop="region"
            align="center"
            header-align="center"  :show-overflow-tooltip="true"
            label="区域"
            width="100">
          </el-table-column>
          <el-table-column
            prop="tel"
            label="电话"
            align="left" width="100"  :show-overflow-tooltip="true"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="businesshours"
            label="营业时间"
            align="left" width="100"  :show-overflow-tooltip="true"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            align="left"    :show-overflow-tooltip="true"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="tiktokid" :show-overflow-tooltip="true"
            align="left"
            header-align="center"
            label="抖音ID"
            width="100">
          </el-table-column>
          <el-table-column
            prop="meituanid" :show-overflow-tooltip="true"
            align="left"
            header-align="center"
            label="美团ID"
            width="100">
          </el-table-column>
          <el-table-column
            label="收银账号"
            align="center"
            width="80">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="setUnionpay(scope.row)">收银账号
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="操作" fixed="right"
            align="center"
            width="150">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
  </el-row>
</template>
<script>
  import DeptEdit from './DeptEdit';
  import UnionpayTable from './UnionpayTable';
  import {listAllStore as getListData} from '@/api/set/dept';
  import {detailglob} from '@/api/set/parameter';

  export default {
    name: 'DeptListTenant',
    data() {
      return {
        seen: false,
        Independentserial:'',
        dialogFormVisible: false,
        searchdata:{dname:'',region:'',nature:'',level:'',address:''},
        regionlist:[],
        naturelist:[],
        levellist:[],
        loading: true,
        serialnum: '',
        canAddStore:false,
        parentdname: '',
        parentdserial: '',
        fdpath: '',
        independentName: '',
        dsortnum: '',
        tableData: []
      }
    },
    methods: {
      handleEdit(index, row) {
          this.$refs.DataContactEdit.initData(row.independentserial,row.tenantid)
          this.OpenDialog();
      },
      bindGrid() {
        getListData({noxy: '1'}).then(response => {
          this.tableData = response.data.obj
          // 定义排序函数
          this.tableData.sort((a, b) => {
            // 比较leibie
            if (a.region !== b.region) {
              return a.region.localeCompare(b.region);
            }
            // 比较pingpai
            return a.dname.localeCompare(b.dname);

          });
        }).catch((error) => {
          console.log(error)
        });
      },
      OpenDialog() {//修改部门
        this.$refs.DataContactEdit.show()
      },
      setUnionpay(row){
        this.$refs.UnionpayTable1.show(row.dname, row.independentserial, row.tenantid);
      },

      //导出
      excelPort() {
          var tabledata = this.tableData ;

          for (let i in tabledata) {
            tabledata[i].id=tabledata[i].tenantid+tabledata[i].independentserial;
          }
          var date = new Date();
          var y = 1900 + date.getYear();
          var m = "0" + (date.getMonth() + 1);
          var d = "0" + date.getDate();
          let header1 = ["门店ID","门店名称", "等级", "性质", "地区", "省", "市","县","详细地址", "电话", "营业时间", "抖音号","美团号"]
          let column1 = ["id","dname", "deptlevel", "nature", "region", "province", "city","county","address", "tel", "businesshours",  "tiktokid","meituanid"]

          var name = '门店' + y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length)
          this.$exportExcel(header1, column1, tabledata, name)
      },
    },
    mounted() {
      var userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      this.Independentserial=userInfoModel.independentserial;
      detailglob({paraname:'门店所属大区'}).then(response=> {
        if (response.data.code == 0&&response.data.obj&&response.data.obj.paracontent) {
          this.regionlist=response.data.obj.paracontent.split(';');
        }
      });
      detailglob({paraname:'门店性质分类'}).then(response=> {
        if (response.data.code == 0&&response.data.obj&&response.data.obj.paracontent) {
          this.naturelist=response.data.obj.paracontent.split(';');
        }
      });
      detailglob({paraname:'门店等级'}).then(response=> {
        if (response.data.code == 0&&response.data.obj&&response.data.obj.paracontent) {
          this.levellist=response.data.obj.paracontent.split(';');
        }
      });
      this.bindGrid();
    },
    components: {
      DeptEdit,
      UnionpayTable
    }
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/dept/DeptListTenant.vue